import React, { useContext, useEffect } from 'react';
import CustomerContact from '../CustomerContact';
import TotalsPanel from '../../cart/TotalsPanel';
import CartContext from '../../../../contexts/CartContext';
import { useCustomer } from '../../../../contexts/CustomerContext';

type Props = {
  setNextName: React.Dispatch<React.SetStateAction<string>>;
  setPreNextAction: React.Dispatch<React.SetStateAction<() => () => Promise<boolean>>>;
}

const Step2 = ({setNextName, setPreNextAction}: Props) => {
  const { cart, setCartState } = useContext(CartContext);
  const { customer, user } = useCustomer();

  useEffect(() => {
    setPreNextAction(() => async () => {return true});
    setNextName("Next");
    window.scrollTo(0, 0);
  }, []);

  // Prefill blank contact fields from the signed-in user's profile.
  // Email comes from Firebase (authoritative); first/last/phone come from
  // saved defaults if we have any. Never overwrite user-typed values.
  useEffect(() => {
    if (!user) return;
    const ca = cart.customerAddress ?? {};
    const patch: any = {};
    const fbEmail = user.email ?? customer?.email ?? undefined;
    if (fbEmail && !ca.email) patch.email = fbEmail;
    const fbFirst = customer?.default_delivery_address?.firstName
      ?? (user.displayName?.split(' ').shift() || undefined);
    const fbLast = customer?.default_delivery_address?.lastName
      ?? (user.displayName?.split(' ').slice(1).join(' ') || undefined);
    if (fbFirst && !ca.firstName) patch.firstName = fbFirst;
    if (fbLast && !ca.lastName) patch.lastName = fbLast;
    if (customer?.phone && !ca.phone) patch.phone = customer.phone;
    if (Object.keys(patch).length > 0) {
      setCartState({ ...cart, customerAddress: { ...ca, ...patch } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.uid, customer?.id]);

  return (
    <div className='checkout-parent'>
      <div className='checkout-main'>
        <CustomerContact/>
      </div>
      <div className='checkout-right'>
        <TotalsPanel hideDiscount={true} hideTax={true} hideTotal={true} hideInactive={true}/>
      </div>
    </div>
  )
}

export default Step2